import React from 'react';
import PropTypes from 'prop-types';

import { Btn, Icon } from './styles';

const HamburgerButton = ({ isOpen, ...rest }) => (
  <Btn type="button" aria-label="Menu" aria-expanded={isOpen} {...rest}>
    <Icon />
  </Btn>
);

HamburgerButton.defaultProps = { isOpen: false };
HamburgerButton.propTypes = { isOpen: PropTypes.bool };

export default HamburgerButton;
